import React from 'react';
import { Route } from 'react-router-dom';
import LiveMonitorRoutes from './LiveMonitor/routes';
const routes = () => [<LiveMonitorRoutes key="LiveMonitorRoutes" />];

const LiveMonitorRoute = () => <Route component={routes} />;

export default LiveMonitorRoute;



// WEBPACK FOOTER //
// src/modules/screens/livemonitor/routes.js